import { render, staticRenderFns } from "./ModalNuevoCiclo.vue?vue&type=template&id=150a97e2&"
import script from "./ModalNuevoCiclo.vue?vue&type=script&lang=js&"
export * from "./ModalNuevoCiclo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports